// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fcfbd094","455":"1d56c80e","977":"b9aa47f0"}[chunkId] + ".chunk.js";
};